import { render, staticRenderFns } from "./ProductsPagination.vue?vue&type=template&id=32e4f5e8&"
import script from "./ProductsPagination.vue?vue&type=script&lang=js&"
export * from "./ProductsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e4f5e8')) {
      api.createRecord('32e4f5e8', component.options)
    } else {
      api.reload('32e4f5e8', component.options)
    }
    module.hot.accept("./ProductsPagination.vue?vue&type=template&id=32e4f5e8&", function () {
      api.rerender('32e4f5e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/management/products/views/components/ProductsPagination.vue"
export default component.exports